import { useState } from "react"
import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"
import useStore from "../../../store"
import { NeutralButton } from "../../common/Buttons"
import { FaCheck, FaTimes, FaRedo } from "react-icons/fa"
import Spinner from "../../common/Spinner"
import FieldAuditUnitRow from "./FieldAuditUnits/FieldAuditUnitRow"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"
import { AccordionRoot } from "../../ui/accordion"
import { Flex } from "@chakra-ui/react"

export default function AuditUnitUploadQueue({ fieldAuditId }) {
  const { requestQueue, dequeueRequest, fieldAuditUnits, retryRequest } = useStore()
  const [isActionConfirmDrawerOpen, setIsActionConfirmDrawerOpen] = useState(false)
  const [openUnitId, setOpenUnitId] = useState([])

  const requestStatusIcon = (request) => {
    if (request.status === 'pending') {
      return <Spinner color="grey-300" height="20px" width="20px" strokeWidth={6} />
    } else if (request.status === 'success') {
      return <FaCheck color='green' />
    } else {
      return (
        <div className="flex items-center gap-2">
          <FaRedo onClick={() => retryRequest(request.id, true)} />
          <FaTimes color='red' />
        </div>
      )
    }
  }

  if (!fieldAuditUnits?.data || requestQueue.filter(request => request.meta.fieldAuditId === fieldAuditId).length === 0) {
    return null
  }

  return (
    <>
      <Widget>
        <WidgetHeader title="Upload Queue" />
        <WidgetBody isVisible={true}>
          <Flex flexDirection="column" gap={3}>
            <Flex flexDirection="column">
              {requestQueue.filter(request => request.meta.fieldAuditId === fieldAuditId).map((request) => (
                <AccordionRoot
                  key={request.id}
                  type="single"
                  collapsible
                  value={openUnitId}
                  onValueChange={(e) => setOpenUnitId(e.value)}
                >
                  <FieldAuditUnitRow
                    fieldAuditUnit={fieldAuditUnits?.data?.find(unit => unit.id === request.meta.auditUnitId)}
                    fieldAuditId={fieldAuditId}
                  >
                    {requestStatusIcon(request)}
                  </FieldAuditUnitRow>
                </AccordionRoot>
              ))}
            </Flex>
            {requestQueue.filter(request => request.meta.fieldAuditId === fieldAuditId).some(request => request.status === 'failed') &&
              <NeutralButton
                text="Retry All"
                onClick={() =>
                  requestQueue.filter(request => request.meta.fieldAuditId === fieldAuditId).forEach(request => retryRequest(request.id))
                }
              />
            }
            <NeutralButton text="Clear Queue" onClick={() => setIsActionConfirmDrawerOpen(true)} />
          </Flex>
        </WidgetBody>
      </Widget>
      <ActionConfirmDrawer
        isOpen={isActionConfirmDrawerOpen}
        onClose={() => setIsActionConfirmDrawerOpen(false)}
        onCancel={() => setIsActionConfirmDrawerOpen(false)}
        onConfirm={() => requestQueue.filter(request => request.meta.fieldAuditId === fieldAuditId).forEach(request => dequeueRequest(request.id))}
        title="Clear Queue"
        body={<div className="flex flex-col items-center justify-center text-center">
          <p className="text-lg font-bold">Are you sure you want to clear the upload queue?</p>
          <p className="text-sm text-gray-500">This action cannot be undone.</p>
        </div>}
      />
    </>
  )
}